export enum AlertType {
  Success = 'success',
  Warning = 'warning',
  Danger = 'danger',
  Info = 'info',
}

export interface ShowAlert {
  text: string;
  kind: AlertType;
  dismissAfter: number;
  persistent?: boolean;
}
